import { faBagShopping } from "@jewlr/pro-light-svg-icons/faBagShopping"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import {
  IS_NA,
  IS_JEWLR,
  IS_INT,
  jewlr_t,
  getGlobalECookieData,
} from "helpers/application"
import { to_currency } from "helpers/number"

import CheckoutButton from "./checkout-button"
import { Panel, TitleDivider } from "./components"
import AcceptPayments from "./footer/accept-payments"

const OrderSummary = ({ cartSummaryRef }) => {
  const summary = useSelector((state) => state.cart.summary)

  let currencyCode = summary.currency_code
  if (IS_INT()) {
    const globalEData = getGlobalECookieData()
    currencyCode = globalEData?.currencyCode || ""
  }

  return (
    <Panel
      aria-labelledby="cart-summary-heading"
      className="tablet:py-24 pb-0 pt-20"
    >
      <div className="text-14 leading-21 font-bold" ref={cartSummaryRef}>
        <TitleDivider className="mb-10">
          <div className="flex items-center gap-8">
            <FontAwesomeIcon
              className="text-18 tablet:text-20"
              icon={faBagShopping}
            />
            <h2
              className="text-20 leading-22 font-bold"
              id="cart-summary-heading"
            >
              {jewlr_t("Cart")} Summary
            </h2>
          </div>
        </TitleDivider>
        <Divider className="tablet:block bg-grey-20 my-10 hidden" />
        <dl>
          <div className="flex justify-between py-8">
            <dt>Item Subtotal</dt>
            <dd data-ge-basket-subtotals>{summary.order_total}</dd>
          </div>
          {summary.promo_code?.promo_code_applied && (
            <div className="flex justify-between">
              <dt className="text-green-darker">
                Promo Code: {summary.promo_code.promo_code_applied}
              </dt>
              <dd
                className="text-green-darker"
                data-cy="cart-promo-code-price"
                data-ge-basket-discounts
              >
                {to_currency(summary.promo_code.promo_code_discount_amount, {
                  precision: 2,
                })}
              </dd>
            </div>
          )}
          {summary.bmsm_discount !== 0 && (
            <>
              <div className="flex justify-between pt-8">
                <dt className="text-green-darker">
                  Buy More Save More Discount
                </dt>
                <dd className="text-green-darker">
                  {to_currency(summary.bmsm_discount, { precision: 2 })}
                </dd>
              </div>
              <p className="text-grey-65 text-12 leading-12">
                {summary.bmsm_percentage}% off items {summary.bmsm_message}
              </p>
            </>
          )}
          {summary.promotion_discount !== 0 && (
            <>
              <div className="flex justify-between pt-8">
                <dt className="text-green-darker">
                  {summary.promotion_description}
                </dt>
                <dd className="text-green-darker">
                  {to_currency(summary.promotion_discount, {
                    precision: 2,
                  })}
                </dd>
              </div>
              <p className="text-grey-65 text-12 leading-12">
                {summary.promotion_percentage}% off items{" "}
                {summary.promotion_message}
              </p>
            </>
          )}
          {IS_NA() && (
            <div className="flex justify-between pt-8">
              <dt className="text-grey-62">Sales Tax</dt>
              <dd className="text-grey-62 font-medium">
                Calculated at checkout
              </dd>
            </div>
          )}
          <Divider className="bg-grey-20 my-10" />
          <div className="pb-18 flex justify-between pt-8">
            <dt>Estimated Total</dt>
            <dd data-ge-basket-totals>
              {summary.total} {currencyCode}
            </dd>
          </div>
        </dl>
      </div>
      <CheckoutButton cartSummaryRef={cartSummaryRef} />
      {IS_JEWLR() && (
        <>
          <p className="tablet:text-8 tablet:font-normal text-11 text-grey-500 mt-24 text-center font-medium">
            JEWLR USES TRANSPORT LAYER SECURITY (TLS) ENCRYPTION.
          </p>
          <Media lessThan="tablet">
            <Divider className="mt-16" />
            <AcceptPayments />
            <Divider className="mb-0 mt-16" />
          </Media>
        </>
      )}
    </Panel>
  )
}

OrderSummary.propTypes = {
  cartSummaryRef: PropTypes.object,
}

export default OrderSummary
